import React from "react";
import moment from "moment";
import {Box, Container, FormControlLabel, List, ListItem, Switch} from "@mui/material";
import Calendar from "./partial/Calendar";
import SlideDatepicker from "./partial/SlideDatepicker";

export default function Schedules(props) {
  const [state, setState] = React.useState({
    date: sessionStorage.getItem("schedules_date") || moment().format("yyyy-MM"),
    gekkan: false,
    pg: 1,
    stopRender: true
  });

  return (
    <Container
      maxWidth = "sm"
      sx = {{p: 0, flexGrow: 1}}
    >
      <Box
        className = "bgcolor-white"
        position = "sticky"
        sx = {{width: "100%", top: 55, pt: 2, textAlign: "center", zIndex: 1}}
      >
        <SlideDatepicker
          setState = {setState}
          state = {state}
          ymdFg = {false}
        />
        <List>
          <ListItem>
            <FormControlLabel
              control = {<Switch onChange = {(e) => setState({...state, gekkan: e.target.checked})} />}
              label = "月間"
              sx = {{ml: "auto"}}
            />
          </ListItem>
        </List>
      </Box>
      {new Date(state.date + "-01").toLocaleDateString() !== "Invalid Date" &&
      <Calendar
        setState = {setState}
        setToastState = {props.setToastState}
        state = {state}
        toastState = {props.toastState}
      />}
    </Container>
  );
};
